export const webType = process.env.REACT_APP_WEBTYPE
const snaUrl = process.env.REACT_APP_API_URL_SNA
const hamUrl = process.env.REACT_APP_API_URL_HAM

export let apiUrl = webType === 'SNA' ? snaUrl : webType === 'HAM' ? hamUrl : null

export let primaryColor = webType === 'SNA' ? "#244093" : webType === 'HAM' ? "#E54E26" : null

export let secondaryColor = webType === 'SNA' ? "#E54E26" : webType === 'HAM' ? "#244093" : null